module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-status-paused-icon.9b37f33b.svg";